<template>
  <div>
    <!-- <h2>Invoicing</h2> -->
    <div class="alBind">
      <van-nav-bar title="开票信息" left-arrow fixed @click-left="saveBill" />
      <div class="content">
        <van-form ref="formPhone">
          <div class="phoneBox">
            <van-field
              v-for="(it, index) in tKeys"
              :key="index"
              v-model="currentValue[it]"
              :label="ticketList[it]"
              :disabled="currentValue.isConfirm == '1'"
              :placeholder="
              currentValue.isConfirm == '1' ? '' : '请输入' + ticketList[it]
            "
              input-align="right"
            />
          </div>
        </van-form>
        <div class="bottom">
          <van-button @click="saveBill" block class="confirm" round type="info">
            确定
            <img class="blueSha" src="../../assets/img/blueshadow.png" alt />
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Invoicing",
  data() {
    return {
      currentValue: {},
      ticketList: [],
      tKeys: [] // 保存票据信息的keys
    }
  },
  mounted() {
    this.currentValue = this.$route.query
    this.getTicketMess(this.currentValue)
  },
  methods: {
    saveBill() {
      this.$router.go(-1)
    },
    getTicketMess(it) {
      this.request({
        url: "/business/getH5BillField",
        method: "post",
        params: {
          dataType: it.dataType,
          deptId: it.deptId
        }
      }).then((res) => {
        if (res.data.code == 1000) {
          console.log(res)
          if (res.data.result) {
            this.ticketList = res.data.result

            if (this.tKeys.length > 0) {
              this.tKeys.forEach((it) => {
                if (this.currentValue[it] == undefined) {
                  delete this.currentValue[it]
                }
              })
            }
            this.tKeys = Object.keys(this.ticketList)

            for (var i in res.data.result) {
              if (!this.currentValue[i]) {
                this.$set(this.currentValue, i, "")
              }
            }
          }
        } else {
          if (!res.data.errorMessage) {
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message
            // }).then(() => {})
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              message: res.data.message,
              status: "2",
              textSize: "12"
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alBind {
  padding-top: 60px;
  padding-left: 15px;
  padding-right: 15px;
  height: 100vh;
  box-sizing: border-box;

  ::v-deep .van-icon {
    color: #666;
    text-align: center;
  }
  ::v-deep .van-nav-bar__title {
    font-family: PingFangSC-Semibold;
    font-size: 17px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 600;
  }
  .content {
    margin: 0px auto;
    width: 345px;
    background: #ffffff;
    border-radius: 10px 10px 0px 0px;
    height: 100%;
    padding-top: 14px;
    box-sizing: border-box;
    .billBox {
      position: relative;
      border-bottom: 1px solid #eee;

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
      > img {
        width: 14px;
        position: absolute;
        top: 16px;
        right: 10px;
      }
      ::v-deep .van-field__right-icon {
        color: rgba(0, 0, 0, 0.3);
      }
    }
    .phoneBox {
      ::v-deep .van-field__label {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 400;
      }
      ::v-deep .van-field__control {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
      }
    }
    .bottom {
      height: 83%;
      display: flex;
      align-items: flex-end;
    }
  }
  .van-cell::after{
    border-color: #EEEEEE !important;
  }
}
.confirm {
  width: 305px;
  height: 44px;
  color: #fff !important;
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
  margin: 0 auto;

  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 700;
  position: relative;
  margin-bottom: 10px;
  .blueSha {
    width: 286px;
    height: 34px;
    position: absolute;
    left: 50%;
    top: 68%;
    transform: translateX(-50%);
  }
}
</style>
